const labelsMap = {
  0: 'Invoice Notes',
  1: 'Estimate Notes',
  2: 'Invoice Notes',
};

export const getAppointmentNotesLabel = (entityType) => {
  return labelsMap[entityType] || 'Notes';
};
